<template>
  <div v-if="result" style="min-height:28px;">
      <v-btn @click="showDialog = true" small elevation="0" class="ml-1">
          <v-icon class="mr-1" small>mdi-share-variant</v-icon>
          {{ $t('dialog.share_result.button') }}
      </v-btn>
      <v-row justify="center">
          <v-dialog
                  v-model="showDialog"
                  persistent
                  max-width="400"
          >
              <v-card rounded>
                  <v-card-title>
                      <v-icon class="mr-2">mdi-share-variant</v-icon>
                      {{ $t('dialog.share_result.title') }}
                  </v-card-title>
                  <v-card-text>
                      <p class="body-2">
                          {{ $t('dialog.share_result.text') }}
                      </p>
                      <v-card outlined rounded color="back_accent">
                          <v-card-text>
                              <div v-if="!disableToggle" class="d-flex align-center">
                                  <v-icon @click="toggleShare" x-large class="mr-2" style="cursor:pointer" :color="toggleIcon.color">
                                      {{toggleIcon.icon}}
                                  </v-icon>
                                  <p class="ma-0">
                                      {{ $t('dialog.share_result.toggle_text') }}
                                      <strong v-if="isShared">{{$t('dialog.share_result.toggle_on')}}</strong>
                                      <strong v-else>{{$t('dialog.share_result.toggle_off')}}</strong>
                                  </p>
                              </div>
                              <div v-else class="d-flex align-center">
                                  <v-progress-circular
                                          class="mr-2"
                                          indeterminate
                                  ></v-progress-circular>
                                  <p class="ma-0">
                                      {{$t('message.loading')}}
                                  </p>
                              </div>
                          </v-card-text>
                      </v-card>

                      <!-- sharing options -->
                      <v-card elevation="0" v-if="sharedComputed">
                          <v-card-text>
                              <strong>{{ $t('dialog.share_result.options') }}</strong>
                              <div v-if="key !== 'topics'" v-for="(item, key) in shareOptions" :key="key" class="d-flex align-center">
                                  <v-icon @click="toggleShareOption(key)" large class="mr-2" style="cursor:pointer" :color="getToggleIcon(item).color">
                                      {{ getToggleIcon(item).icon }}
                                  </v-icon>
                                  <p class="ma-0">
                                      {{ $t(`result.${key}.title`) }}
                                  </p>
                              </div>
                              <div v-if="shareOptions.motivation && result.custom_data.result_type !== 1" class="d-flex align-center ml-3">
                                  <v-icon @click="toggleShareOption('topics')" class="mr-2" style="cursor:pointer" :color="getToggleIcon(shareOptions.topics).color">
                                      {{ getToggleIcon(shareOptions.topics).icon }}
                                  </v-icon>
                                  <p class="ma-0 body-">
                                      {{ $t('result.motivators.groups.2') }} / {{ $t('result.motivators.groups.3') }}
                                  </p>
                              </div>
                          </v-card-text>
                      </v-card>

                      <v-card v-if="isShared" rounded elevation="0" class="mt-5">
                          <v-card-text class="pa-0">
                              <p class="mb-0">Odkaz pro sdílení:</p>
                              <div class="d-flex align-center">
                                  <div id="shareLink" style="inline-size:280px;overflow-wrap: break-word;" class="caption mr-2 back_accent pa-1">
                                      {{shareLink}}
                                  </div>
                                  <v-tooltip top>
                                      <template v-slot:activator="{ on, attrs }">
                                          <v-btn
                                                  v-bind="attrs"
                                                  v-on="on"
                                                  type="button"
                                                  elevation="0"
                                                  @click="copyClip()">
                                              <v-icon small>
                                                  mdi-content-copy
                                              </v-icon>
                                          </v-btn>
                                      </template>
                                      <span>kopírovat odkaz</span>
                                  </v-tooltip>
                              </div>
                          </v-card-text>
                      </v-card>

                  </v-card-text>

                  <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn @click="diagClose" text>
                          {{$t('message.close')}}
                      </v-btn>
                  </v-card-actions>

              </v-card>

          </v-dialog>
      </v-row>
  </div>
</template>

<script>
export default {
  name: "ShareResult",
  props: ['result', 'type'],
  data(){
    return {
      disableToggle: false,
      isShared: false,
      shareOptions: {},
      showDialog: false,
    }
  },
  computed: {
    sharedComputed() {
      return this.type === 'team' ? this.$store.getters['team/isShared'] : this.$store.getters['diagnostic/isShared'];
    },
      /*
    sharing() {
      if (this.result.custom_data.share) {
        if (this.result.custom_data.share.isShared) {
          this.isShared = this.result.custom_data.share.isShared
        }
        if (this.result.custom_data.share.options) {
          this.shareOptions = this.result.custom_data.share.options
        }
      }
      //return !!(this.result.custom_data.share && this.result.custom_data.share.isShared);
    },
       */
    toggleIcon() {
      return this.isShared ? {icon:'mdi-toggle-switch',color:'green'} : {icon:'mdi-toggle-switch-off',color:null}
    },
    shareLink() {
        if (this.type === 'team') {
            return window.location.origin + '/share/team/' + this.result.uuid
        }
        return window.location.origin + '/share/result/' + this.result.uuid

    },
  },
  methods: {
    getToggleIcon(state) {
      return state ? {icon:'mdi-toggle-switch',color:'green'} : {icon:'mdi-toggle-switch-off',color:null}
    },
    toggleShare() {
      this.isShared = !this.isShared
      this.setShare()
    },
    toggleShareOption(option) {
      this.shareOptions[option] = !this.shareOptions[option]
      this.setShare()
    },
    async setShare() {
      if (!this.disableToggle) {
        this.disableToggle = true
        let cdata = Object.assign({},this.result.custom_data)
        if (!cdata.share) {
          cdata.share = {}
        }
        cdata.share.isShared = this.isShared
        cdata.share.options = this.shareOptions
          let res = false;
          if (this.type === 'team') {
              let team = {...this.result}
              team.custom_data = cdata;
              res = await this.$store.dispatch('team/updateTeam',team);
          } else {
              res = await this.$store.dispatch('diagnostic/update',{uuid:this.result.uuid,form:cdata,setLoading:false});
          }
          if (res && res.updated) {
              if (res.updated) {
              } else {
                  this.$store.dispatch('notification/push', {
                      timeout: 3000,
                      text: this.$t('message.alert.error'),
                      color: 'danger'
                  },{root:true})
              }
              this.disableToggle = false
          }
      }
    },
    diagClose() {
      this.showDialog = false;
    },
    copyClip() {
      let selection = document.getSelection();
      let range = document.createRange();
      //range.selectNode(el);
      range.selectNode(document.getElementById('shareLink'));
      selection.removeAllRanges();
      selection.addRange(range);      document.execCommand('copy');
      this.$store.dispatch('notification/push', {timeout: 3000, text: this.$t('message.alert.copy_link'), color: 'success', icon: 'mdi-content-copy'}, {root: true})
    },
    updateShare() {
        this.shareOptions = this.type === 'team' ? this.$store.getters['team/shareOptions'] : this.$store.getters['diagnostic/shareOptions'];
        this.isShared = this.type === 'team' ? this.$store.getters['team/isShared'] : this.$store.getters['diagnostic/isShared'];
    }
  },
  created() {
      this.updateShare();
  },
    watch: {
      result() {
          this.updateShare();
      }
    }
}
</script>
